export default __webpack_public_path__ + "assets/insets2.png";